import { PortugalCOVIDTree } from "./PortugalCOVIDTree";

export * from "./PortugalCOVIDTree";

export default PortugalCOVIDTree;
